import accInventoryState from './accountInventory/state'
import accInventoryGetters from './accountInventory/getters'
import accInventoryMutations from './accountInventory/mutations'
import accInventoryActions from './accountInventory/actions'

import oppregAdminState from './oppregAdmin/state'
import oppregAdminGetters from './oppregAdmin/getters'
import oppregAdminMutations from './oppregAdmin/mutations'
import oppregAdminActions from './oppregAdmin/actions'

import accOnboardingState from './accountOnboarding/state'
import accOnboardingGetters from './accountOnboarding/getters'
import accOnboardingMutations from './accountOnboarding/mutations'
import accOnboardingActions from './accountOnboarding/actions'

import requestManagedServicesState from './requestManagedServices/state'
import requestManagedServicesMutations from './requestManagedServices/mutations'
import requestManagedServicesActions from './requestManagedServices/actions'

export default {
  accountInventory: {
    namespaced: true,
    state: accInventoryState,
    getters: accInventoryGetters,
    mutations: accInventoryMutations,
    actions: accInventoryActions
  },
  oppregAdmin: {
    namespaced: true,
    state: oppregAdminState,
    getters: oppregAdminGetters,
    mutations: oppregAdminMutations,
    actions: oppregAdminActions
  },
  accountOnboarding: {
    namespaced: true,
    state: accOnboardingState,
    getters: accOnboardingGetters,
    mutations: accOnboardingMutations,
    actions: accOnboardingActions
  },
  requestManagedServices: {
    namespaced: true,
    state: requestManagedServicesState,
    getters: null,
    mutations: requestManagedServicesMutations,
    actions: requestManagedServicesActions
  }
}
